import { Eyebrow } from "../components/Reveal";
import { imgSrc } from "../lib/api";

export const Sponsors = ({ sponsors }) => {
  if (!sponsors?.length) return null;
  return (
    <section data-testid="sponsors-section" className="mx-auto max-w-7xl px-5 py-16 lg:px-12">
      <Eyebrow color="text-zinc-400">Presented with our partners</Eyebrow>
      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {sponsors.map((s) => (
          <a key={s.name} href={s.url || undefined} target="_blank" rel="noopener noreferrer" data-testid={`sponsor-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="grid h-24 place-items-center rounded-2xl border border-white/10 bg-[#12141C] p-4">
            {s.logo ? <img src={imgSrc(s.logo)} alt={s.name} className="max-h-12 object-contain opacity-80 transition-opacity hover:opacity-100" /> : <span className="font-display text-xl font-bold uppercase text-zinc-200">{s.name}</span>}
          </a>
        ))}
      </div>
    </section>
  );
};
